import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, AfterViewInit, Inject, PLATFORM_ID, Optional, Renderer2 } from '@angular/core';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';
import anime from 'animejs/lib/anime.es.js';
import { TemplateService } from '../web-generator/template-generator/service/template.service';
import { removeUrlQueryParam } from '../util';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements AfterViewInit {
  textWrapper: Element;
  letter = 'letters';
  errorPageImg: string;
  siteInfo: any;
  /** 是瀏覽器端渲染 */
  isBrowser: boolean;
  /** 是網站根路徑的404頁 */
  isRoot404 = true;

  constructor(
    @Inject(PLATFORM_ID) protected platformId: object,
    @Optional() @Inject(RESPONSE) protected response: Response,
    private serverConfigService: ServerConfigService,
    private templateService: TemplateService,
    private render: Renderer2,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (!this.isBrowser) {
      this.response.status(404);
    }
    this.isRoot404 = this.serverConfigService.pathname.split('/').length === 2;
    if (this.isRoot404) {
      const newTitle = `Page not found｜${this.templateService.getSiteName()}`;
      this.templateService.setWebTitle({ title: newTitle, desc: 'Page not found', image: '' });
    }

    this.render.setAttribute(this.document.head.querySelector('link[rel="canonical"]'), 'href', removeUrlQueryParam(this.serverConfigService.getCurrentUrl()));
    this.render.setAttribute(this.document.head.querySelector('meta[property="og:url"]'), 'content', removeUrlQueryParam(this.serverConfigService.getCurrentUrl()));
    this.render.setAttribute(this.document.head.querySelector('meta[name="twitter:url"]'), 'content', removeUrlQueryParam(this.serverConfigService.getCurrentUrl()));
  }

  ngAfterViewInit() {
    if (this.isBrowser) {
      setTimeout(() => {
        this.do_animate();
      });
    }
  }

  do_animate() {
    const textWrapper = document.querySelector('.ml2');
    textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, '<span class=\'letter\'>$&</span>');

    anime.timeline({ loop: true })
      .add({
        targets: '.ml2 .letter',
        scale: [4, 1],
        opacity: [0, 1],
        translateZ: 0,
        easing: 'easeOutExpo',
        duration: 950,
        delay: (el, i) => 70 * i
      }).add({
        targets: '.ml2',
        opacity: 0,
        duration: 1000,
        easing: 'easeOutExpo',
        delay: 1000
      });
  }
}
